import React from "react";
import { Link } from "react-router-dom";
import { Container, Button, Icon } from "semantic-ui-react";

function About() {
    return (
        <Container>
            <div className="about-container">
                <h1>
                    <Icon name="github" /> GitHub User Finder
                </h1>

                <div style={{ marginBottom: "2rem", padding: "1.5rem", background: "rgba(102, 126, 234, 0.05)", borderRadius: "15px", borderLeft: "4px solid #667eea" }}>
                    <h3>
                        <Icon name="heart" style={{ color: "#e74c3c" }} />
                        Developed By: Rudreshwar Baranwal
                    </h3>
                    <p style={{ marginTop: "1rem" }}>
                        <Button
                            as={Link}
                            to="https://github.com/devrudra9"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "white"
                            }}
                            icon="github"
                            content="View on GitHub"
                        />
                    </p>
                </div>

                <div style={{ marginBottom: "2rem", padding: "1.5rem", background: "#f0f7ff", borderRadius: "15px", borderLeft: "4px solid #3498db" }}>
                    <h3>
                        <Icon name="info circle" style={{ color: "#3498db" }} />
                        What is GitHub User Finder?
                    </h3>
                    <p>
                        This is a powerful web application that allows you to search and discover GitHub developers from all over the world. Simply enter a username or name, and instantly access detailed profiles and statistics.
                    </p>
                </div>

                <div style={{ marginBottom: "2rem", padding: "1.5rem", background: "#f0fff4", borderRadius: "15px", borderLeft: "4px solid #27ae60" }}>
                    <h3>
                        <Icon name="star" style={{ color: "#f39c12" }} />
                        Features
                    </h3>
                    <ul style={{ marginLeft: "2rem", fontSize: "1.05rem", lineHeight: "1.8" }}>
                        <li>🔍 Search GitHub users by username or name</li>
                        <li>👤 View detailed user profiles with avatar and bio</li>
                        <li>📊 See comprehensive GitHub statistics</li>
                        <li>👥 View followers and following information</li>
                        <li>📚 Browse popular repositories with descriptions</li>
                        <li>⭐ Check repository stars and programming languages</li>
                        <li>🔗 Direct links to GitHub profiles and repositories</li>
                        <li>📱 Fully responsive design for mobile and desktop</li>
                    </ul>
                </div>

                <div style={{ marginBottom: "2rem", padding: "1.5rem", background: "#fef5e7", borderRadius: "15px", borderLeft: "4px solid #f39c12" }}>
                    <h3>
                        <Icon name="lightbulb" style={{ color: "#f39c12" }} />
                        How to Use
                    </h3>
                    <ol style={{ marginLeft: "2rem", fontSize: "1.05rem", lineHeight: "1.8" }}>
                        <li>Enter a GitHub username in the search box</li>
                        <li>Click the "Search" button to find users</li>
                        <li>Click "View Profile" on any user card</li>
                        <li>Explore their complete GitHub information and repositories</li>
                        <li>Visit their full GitHub profile for more details</li>
                    </ol>
                </div>

                <div style={{ marginBottom: "2rem", padding: "1.5rem", background: "#f4ecf7", borderRadius: "15px", borderLeft: "4px solid #9b59b6" }}>
                    <h3>
                        <Icon name="shield alternate" style={{ color: "#9b59b6" }} />
                        API Information
                    </h3>
                    <p>
                        This application uses the official GitHub API to fetch real-time data about users and repositories. Note that auto-suggestions are disabled to comply with GitHub's privacy policy.
                    </p>
                </div>

                <div style={{ textAlign: "center", marginTop: "2rem", paddingTop: "2rem", borderTop: "2px solid #eee" }}>
                    <p style={{ fontSize: "0.9rem", color: "#999" }}>
                        Made with <Icon name="heart" style={{ color: "#e74c3c" }} /> for the Developer Community
                    </p>
                </div>
            </div>
        </Container>
    );
}
export default About;
